




import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import axios from 'axios';
import { PropType } from 'vue';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { ProductType } from '~/types/solepro/PageBuilder';
import { extendProductsForBox } from '~/utils/solepro/products';
import PLPProductBox from '../PLPProductBox.vue';

export default defineComponent({
    props:{
        node: {
            type: Object as PropType<ProductType>,
            required: true
        },
    },
    components:{
        PLPProductBox    },
    setup(props) {
        const allCategories = ref([]);
        const item = ref();
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        useFetch(async ()=>{
            const categoryStore = useCategoryStore()
            categoryStore.load()
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            const res = await axios.post('/sole-api/product/pro/getProductBaseDataForBox', {skus: content.skus})
            const products = res.data;
            const items = extendProductsForBox(allCategories.value, products).map(el => {
                return {
                    ...el,
                    box_description: el.hot_topics_description ?? el.box_description
                }
            });
            item.value = items.length>0 ? items[0] : null;
        })
        return {item}
    },
})
